export default __webpack_public_path__ + "static/1-e65bf7ab45f427d47c2efd53fea1f63d.jpg";